import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import SectionTitleWidget from "../../../../../components/SectionTitleWidget/SectionTitleWidget";
import MarketProductsList from "../../listings/products/MarketProductsList";
import ProductCategory from "../overview/ProductCategory";

import s from "./RelatedListings.module.scss";

export default function RelatedListings({
	product,
	products = [],
	updateSection = () => {},
	viewCategoryProducts = () => {},
}) {
	const { ref, inView } = useInView({
		threshold: 0.5,
		initialInView: true,
	});

	useEffect(() => {
		//if (inView) updateSection("related");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView]);

	return (
		<div className={s.root} id="related" ref={ref}>
			<div className={s.section}>
				<SectionTitleWidget
					title="Other Datasets like this"
					className={s.sectionTitle}
				/>

				<ProductCategory
					category={product.category}
					onClick={viewCategoryProducts}
				/>

				<MarketProductsList products={products} />
			</div>
		</div>
	);
}
